import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { fetchLeaderboard, } from "../lib/api";
export function useLeaderboard(initial) {
    const pageSize = initial.pageSize ?? 25;
    const [page, setPage] = useState(0);
    const [difficulty, setDifficultyState] = useState(initial.difficulty);
    const [boardType, setBoardTypeState] = useState(initial.boardType ?? "alltime");
    const opts = {
        difficulty,
        limit: pageSize,
        offset: page * pageSize,
        ...(boardType === "daily" && initial.dailyDate
            ? { daily: initial.dailyDate }
            : {}),
        ...(boardType === "puzzle" && initial.puzzleId
            ? { puzzleId: initial.puzzleId }
            : {}),
    };
    const { data, isLoading, isError } = useQuery({
        queryKey: ["leaderboard", difficulty, boardType, page, initial.dailyDate, initial.puzzleId],
        queryFn: () => fetchLeaderboard(opts),
        placeholderData: (prev) => prev, // keep previous data while fetching
    });
    const entries = data?.entries ?? [];
    return {
        entries,
        isLoading,
        isError,
        page,
        totalFetched: entries.length + page * pageSize,
        hasMore: entries.length === pageSize,
        nextPage: () => setPage((p) => p + 1),
        prevPage: () => setPage((p) => Math.max(0, p - 1)),
        setDifficulty: (d) => {
            setDifficultyState(d);
            setPage(0);
        },
        setBoardType: (t) => {
            setBoardTypeState(t);
            setPage(0);
        },
        difficulty,
        boardType,
    };
}
